import WhiteLabel from "../../models/WhiteLabels";
import WhiteLabelsService from "../../services/crud/WhiteLabelsService";
import { TableProps } from "./types";
import Booking from "../../models/Booking";
import GenericItemsTable from "./GenericItemsTable";
import { WhiteLabelFormGenericForm } from "../forms/WhiteLabelForm";

export const GenericWhiteLabelsTable = ({ ...rest }: TableProps<Booking>) => {
  return (
    <GenericItemsTable model={WhiteLabel} form={WhiteLabelFormGenericForm} formCreate={WhiteLabelFormGenericForm} formEdit={WhiteLabelFormGenericForm} service={WhiteLabelsService} {...rest}></GenericItemsTable>
  );
};